<template>
    <v-card>
        <v-card-title>{{
            t('Únete_a_nosotros') }}</v-card-title>
        <v-card-text>
            <v-banner color="primary" icon="mdi-school">
                <template v-slot:text>
                    <strong>Fully-funded PhD student in AI-powered 3D ultrasound</strong> — 15/06/2025 — 
                    Status: Candidate selected, position closed.
                </template>
            </v-banner>
        </v-card-text>
    </v-card>
</template>

<script setup>
import { useI18n } from 'vue-i18n';

const { t } = useI18n();

</script>